// src/hooks/filter/useCategorySubcategories.js
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import MENU_QUERY from '../../api/queries/MenuQuery.gql';

export const useCategorySubcategories = (
    retailerId,
    selectedCategory,
    pricingType,
    enabled = true
) => {
    const [availableSubcategories, setAvailableSubcategories] = useState(new Set());
    
    // Early return if no category - this prevents all the hook logic from running
    const shouldQuery = enabled && !!selectedCategory && selectedCategory !== '' && !!retailerId && !!pricingType;
    
    // Return early if we shouldn't query
    const { data, loading, error } = useQuery(MENU_QUERY, {
        skip: !shouldQuery,
        variables: shouldQuery ? {
            retailerId,
            menuFilter: {
                category: selectedCategory
            },
            menuType: pricingType,
            offset: 0,
            limit: 150,
            sortDir: 'DESC',
            sortKey: 'POPULAR'
        } : undefined,
        fetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: false,
        onCompleted: (data) => {
            if (data?.menu?.products) {
                const subcategories = new Set();
                data.menu.products.forEach(product => {
                    if (product.subcategory && 
                        product.subcategory !== 'DEFAULT' && 
                        product.subcategory !== 'NOT_APPLICABLE' &&
                        product.subcategory !== 'N/A') {
                        subcategories.add(product.subcategory);
                    }
                });
                
                setAvailableSubcategories(subcategories);
            }
        }
    });
    
    // Return empty results if not querying
    if (!shouldQuery) {
        return {
            availableSubcategories: new Set(),
            isLoading: false,
            hasCategory: false
        };
    }
    
    return {
        availableSubcategories,
        isLoading: loading,
        hasCategory: true
    };
};
